<div class="space-y-6" data-testid="overview-content" *transloco="let t">
  <div class="flex justify-between items-center w-full">
    <app-card-title key="project.steps.projectCharter.timeFrame.title" />
    @if (!timeFrameService.isInitialDataLoading() && !this.isButtonDisabled()) {
      <p-button
        type="button"
        (onClick)="onSuggestTimeFrame()"
        [label]="'project.steps.projectCharter.timeFrame.suggest' | transloco"
        appConfirmStepLeaveDirective
      ></p-button>
    }
  </div>

  @if (timeFrameService.isInitialDataLoading()) {
    <app-loading />
  } @else {
    <app-badge-list
      [items]="badgeListItems()"
      [headerInputTemplate]="headerInputTemplate"
      [contentTemplate]="contentTemplate"
    ></app-badge-list>

    <ng-template #headerInputTemplate let-item>
      @if (item.originalItem.includedProjectDescription) {
        <p>
          {{ t('project.steps.projectCharter.timeFrame.includedProjectDescription.true') }}
          <i class="pi pi-check-circle"></i>
        </p>
      } @else if (item.originalItem.includedProjectDescription === false) {
        <p>
          {{ t('project.steps.projectCharter.timeFrame.includedProjectDescription.false') }}
          <i class="pi pi-times-circle"></i>
        </p>
      }
    </ng-template>

    <ng-template #contentTemplate let-item>
      <app-project-time-frame-form
        [timeFrame]="item.originalItem"
        [itemKey]="item.key"
        [disabled]="isButtonDisabled()"
        (savedTimeFrame)="onSaveTimeFrame($event)"
        [precedingTimeFrame]="item.metadata?.precedingTimeFrame"
      ></app-project-time-frame-form>
    </ng-template>
  }
</div>

<!-- Suggest Time Frame Dialog -->
<p-dialog
  [(visible)]="showSuggestDialog"
  [header]="'project.steps.projectCharter.timeFrame.suggestDialog.title' | transloco"
  [modal]="true"
  [closable]="true"
  [style]="{minWidth: '450px'}"
  data-testid="suggest-timeframe-dialog"
>
  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-2">
      <label for="suggested-date">
        {{ 'project.steps.projectCharter.timeFrame.suggestDialog.dateLabel' | transloco }}
      </label>
      <p-datePicker
        [(ngModel)]="suggestedDate"
        inputId="suggested-date"
        dateFormat="dd/mm/yy"
        [showIcon]="true"
        data-testid="suggested-date-input"
        appendTo="body"
      ></p-datePicker>
    </div>
  </div>

  <ng-template #footer>
    <p-button
      [label]="'common.cancel' | transloco"
      severity="secondary"
      (onClick)="onCancelSuggest()"
      data-testid="cancel-suggest-button"
    ></p-button>
    <p-button
      [label]="'project.steps.projectCharter.timeFrame.suggest' | transloco"
      (onClick)="onConfirmSuggest()"
      data-testid="confirm-suggest-button"
    ></p-button>
  </ng-template>
</p-dialog>
